(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["q-home-accordion"] && !window.DesignMode) return;
  try {
    
var QAccordion = class extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('DOMContentLoaded', () => {
      this.init()
    });
  }
  init() {
    let items = this.querySelectorAll(".acc-item")
    items.forEach(item => {
      item.addEventListener("mouseenter", () => {
        items.forEach(ite => {
          ite.classList.remove('act')
        })
        item.classList.add("act")
      })
    })
    let id = this.getAttribute("section-id")
    let className = '.swiper-' + id
    let className1 = '.pagination-' + id
    const swiper = new Swiper(className, {
      loop: true,
      // pagination: {
      //   el: className1
      // }
      navigation: {
        nextEl: '.acco-next',
        prevEl: '.acco-prev',
      }
    })
  }
};
if (!window.customElements.get("q-accordion")) {
  window.customElements.define("q-accordion", QAccordion);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-home-tab-with-slider"] && !window.DesignMode) return;
  try {
    
  var HomeTabWithSlider = class extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll(".htws-tabs")
      this.swiper = null
      document.addEventListener('DOMContentLoaded', () => {
        this.init()
      });
    }
    init() {
      this.items.forEach((item,i) => {
        item.addEventListener("click", () => {
          this.setIndex(i)
          this.swiper.slideToLoop(i);
        })
      })
      let id = this.getAttribute("sid")
      let className = '.swiper-' + id
      this.swiper = new Swiper(className, {
        loop: true,
        navigation: {
          nextEl: '.htws-next',
          prevEl: '.htws-prev',
        },
        on: {
          activeIndexChange:  (e) => {
            this.setIndex(e.realIndex);
          }
        }
      })
    }
    setIndex (i) {
      this.items.forEach(ite => {
        ite.setAttribute("show", "")
      })

      this.items[i].setAttribute("show", "1")
    }
  };
  if (!window.customElements.get("home-tab-with-slider")) {
    window.customElements.define("home-tab-with-slider", HomeTabWithSlider);
  }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-home-tab"] && !window.DesignMode) return;
  try {
    
  var HomeTab = class extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll(".qht-tabs")
      this.contents = this.querySelectorAll(".qht-right-abso")

      document.addEventListener('DOMContentLoaded', () => {
        this.init()
      });
    }
    init() {
      this.items.forEach((item,i) => {
        item.addEventListener("mouseenter", () => {
          this.setIndex(i)
        })
      })
    }
    setIndex (i) {
      this.items.forEach(ite => {
        ite.setAttribute("show", "")
      })
      this.contents.forEach(ite => {
        ite.setAttribute("show", "")
      })
      this.items[i].setAttribute("show", "1")
      this.contents[i].setAttribute("show", "1")
    }
  };
  if (!window.customElements.get("home-tab")) {
    window.customElements.define("home-tab", HomeTab);
  }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-home-video"] && !window.DesignMode) return;
  try {
    
  class HomeVideo extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sectionId = this.getAttribute("section-id")
      let type = this.getAttribute("type")
      let ytb = this.getAttribute("ytb")
      let oVideoWrap = this.querySelector('.hvid-video-rela');   
      let oItem = this.querySelector('.hvid-preview');
      let oVideos = this.querySelector('.hvid-big-video');
      let oMask = this.querySelector('.hvid-mask');
      let oClose = this.querySelector('.hvid-mask-close');

      oItem.addEventListener("click", () => {
        oMask.setAttribute("show", "1")
        if (type == '1') {
          oVideos.play()
        } else {
          oVideoWrap.innerHTML = ytb
        }
      })
      oClose.addEventListener("click", () => {
        oMask.setAttribute("show", "")
        if (type == '1') {
          oVideos.pause()
        } else {
          oVideoWrap.innerHTML = ""
        }
      })
    }
  }
  if (!customElements.get('home-video')) {
    customElements.define('home-video', HomeVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-home-why"] && !window.DesignMode) return;
  try {
    
var HomeWhy = class extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll(".qhw-tabs")
    this.contents = this.querySelectorAll(".qhw-footer")
    document.addEventListener('DOMContentLoaded', () => {
      this.init()
    });
  }
  init() {
    this.items.forEach((item,i) => {
      item.addEventListener("mouseenter", () => {
        this.setIndex(i)
      })
    })
    this.setIndex(0)
  }
  setIndex (i) {
    this.items.forEach(ite => {
      ite.setAttribute("show", "")
    })
    this.contents.forEach(ite => {
      ite.setAttribute("show", "")
    })
    this.items[i].setAttribute("show", "1")
    this.contents[i].setAttribute("show", "1")
  }
};
if (!window.customElements.get("home-why")) {
  window.customElements.define("home-why", HomeWhy);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-newslatter"] && !window.DesignMode) return;
  try {
    
  var QNewsletter = class extends HTMLElement {
    constructor() {
      super();
      this.oBtn = this.querySelector(".qnew-sbumit")
      this.oBtn1 = this.querySelector(".qnew-flex .input-with-button .btn")

      document.addEventListener('DOMContentLoaded', () => {
        this.init()
      });
    }
    init() {
      this.oBtn.addEventListener("click", () => {
        this.oBtn1.click()
      })
    }

  };
  if (!window.customElements.get("q-newletter")) {
    window.customElements.define("q-newletter", QNewsletter);
  }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product-tab-widh-media"] && !window.DesignMode) return;
  try {
    
  class TabWithMedia extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      
      let oGroup = this.querySelectorAll('.ptwm-group');
      oGroup.forEach((g,j) => {
        let oItem = g.querySelectorAll('.ptwm-tab');
        let oImgs = g.querySelectorAll('.ptwm-media-wrap');
        let oMains = g.querySelectorAll('.ptwm-main');
        oItem.forEach((item, index) => {
          item.addEventListener("click", () => {
            oItem.forEach((i) => {
              i.removeAttribute("show")
            })
            oImgs.forEach((i) => {
              i.removeAttribute("show")
            })
            oMains.forEach((i) => {
              i.removeAttribute("show")
            })
            item.setAttribute("show", "1")
            oImgs[index].setAttribute("show", "1")
            oMains[index].setAttribute("show", "1")
          })
        })
      })

      // let oItem = this.querySelectorAll('.ptwm-tab');
      // let oImgs = this.querySelectorAll('.ptwm-media-wrap');
      // let oMains = this.querySelectorAll('.ptwm-main');

      // oItem.forEach((item, index) => {
      //   item.addEventListener("click", () => {
      //     oItem.forEach((i) => {
      //       i.removeAttribute("show")
      //     })
      //     oImgs.forEach((i) => {
      //       i.removeAttribute("show")
      //     })
      //     oMains.forEach((i) => {
      //       i.removeAttribute("show")
      //     })
      //     item.setAttribute("show", "1")
      //     oImgs[index].setAttribute("show", "1")
      //     oMains[index].setAttribute("show", "1")
      //   })
      // })

    }
  }
  if (!customElements.get('tab-with-media')) {
    customElements.define('tab-with-media', TabWithMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product-video-2"] && !window.DesignMode) return;
  try {
    
  class ProductVideo1 extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sectionId = this.getAttribute("section-id")
      let type = this.getAttribute("type")
      let ytb = this.getAttribute("ytb")
      let oVideoWrap = this.querySelector('.pv2-video-rela');   
      let oItem = this.querySelector('.pv2-preview');
      let oVideos = this.querySelector('.pv2-big-video');
      let oMask = this.querySelector('.pv2-mask');
      let oClose = this.querySelector('.pv2-mask-close');

      oItem.addEventListener("click", () => {
        oMask.setAttribute("show", "1")
        if (type == '1') {
          oVideos.play()
        } else {
          oVideoWrap.innerHTML = ytb
        }
      })
      oClose.addEventListener("click", () => {
        oMask.setAttribute("show", "")
        if (type == '1') {
          oVideos.pause()
        } else {
          oVideoWrap.innerHTML = ""
        }
      })
    }
  }
  if (!customElements.get('product-video-1')) {
    customElements.define('product-video-1', ProductVideo1);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product-video-3"] && !window.DesignMode) return;
  try {
    
  class ProductVideo3 extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sectionId = this.getAttribute("section-id")
      let type = this.getAttribute("type")
      let ytb = this.getAttribute("ytb")
      let oVideoWrap = this.querySelector('.pv3-video-rela');   
      let oItem = this.querySelector('.pv3-preview');
      let oVideos = this.querySelector('.pv3-big-video');
      let oMask = this.querySelector('.pv3-mask');
      let oClose = this.querySelector('.pv3-mask-close');

      oItem.addEventListener("click", () => {
        oMask.setAttribute("show", "1")
        if (type == '1') {
          oVideos.play()
        } else {
          oVideoWrap.innerHTML = ytb
        }
      })
      oClose.addEventListener("click", () => {
        oMask.setAttribute("show", "")
        if (type == '1') {
          oVideos.pause()
        } else {
          oVideoWrap.innerHTML = ""
        }
      })
    }
  }
  if (!customElements.get('product-video-3')) {
    customElements.define('product-video-3', ProductVideo3);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-product-video-4"] && !window.DesignMode) return;
  try {
    
  class ProductVideo4 extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let sectionId = this.getAttribute("section-id")
      let type = this.getAttribute("type")
      let ytb = this.getAttribute("ytb")
      let oVideoWrap = this.querySelector('.pv4-video-rela');   
      let oItem = this.querySelector('.pv4-preview');
      let oVideos = this.querySelector('.pv4-big-video');
      let oMask = this.querySelector('.pv4-mask');
      let oClose = this.querySelector('.pv4-mask-close');

      oItem.addEventListener("click", () => {
        oMask.setAttribute("show", "1")
        if (type == '1') {
          oVideos.play()
        } else {
          oVideoWrap.innerHTML = ytb
        }
      })
      oClose.addEventListener("click", () => {
        oMask.setAttribute("show", "")
        if (type == '1') {
          oVideos.pause()
        } else {
          oVideoWrap.innerHTML = ""
        }
      })
    }
  }
  if (!customElements.get('product-video-4')) {
    customElements.define('product-video-4', ProductVideo4);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["q-resources-section"] && !window.DesignMode) return;
  try {
    
  class ResourcesSection extends HTMLElement {
    constructor() {
      super();
      this.init()
    }
    init () {
      let oTabs = this.querySelectorAll('.qrs-li');   
      let oContents = this.querySelectorAll('.qrs-main');
      oTabs.forEach((item,i) => {
        item.addEventListener("mouseenter", () => {
          oTabs.forEach((t,j) => {
            t.setAttribute("show", "")
            oContents[j].setAttribute("show", "")
          })
          item.setAttribute("show", "1")
          oContents[i].setAttribute("show", "1")
        })
      })
    }
  }
  if (!customElements.get('resources-section')) {
    customElements.define('resources-section', ResourcesSection);
  }

  } catch(e) { console.error(e); }
})();
})();
